import { htmlSafe } from '@ember/template';
import { helper as buildHelper } from '@ember/component/helper';

export default buildHelper(function () {
  return htmlSafe(new Date().getFullYear());
});
